import type { Editor } from "@tiptap/vue-3";
import type { Ref } from "vue";
import { createInjectionState, useToggle } from "@vueuse/core";
import { useContextOrThrow } from "ls/composables/useContextOrThrow";
import { readonly, ref } from "vue";
import { useEditorRootElement } from "./useEditorRootElement";

const [useProvideRichTextContext, useRichTextContextFn] = createInjectionState((editor: Ref<Editor | undefined>) => {
  const rootElement = ref<HTMLElement>();
  const { editorElement, key } = useEditorRootElement(editor);
  const [blockHandleOpen, toggleBlockHandleOpen] = useToggle(false);
  const [blockDragging, toggleBlockDragging] = useToggle(false);
  const [updateLinkOpen, toggleUpdateLinkOpen] = useToggle(false);
  const [updateEmbedOpen, toggleUpdateEmbedOpen] = useToggle(false);
  const [updateAiOpen, toggleUpdateAiOpen] = useToggle(false);

  return {
    rootElement,
    editorElement,
    editorElementKey: key,
    blockHandleOpen: readonly(blockHandleOpen),
    toggleBlockHandleOpen,
    blockDragging: readonly(blockDragging),
    toggleBlockDragging,
    updateLinkOpen: readonly(updateLinkOpen),
    toggleUpdateLinkOpen,
    updateAiOpen: readonly(updateAiOpen),
    toggleUpdateAiOpen,
    updateEmbedOpen: readonly(updateEmbedOpen),
    toggleUpdateEmbedOpen,
  };
});

export { useProvideRichTextContext };
export const useRichTextContext = useContextOrThrow(useRichTextContextFn);
